import myAxios from "../utils/request";

export default {
  home(params) {
    return myAxios.get("/api/screen/home", { params });
  },
  thought(params) {
    return myAxios.get("/api/screen/thought", { params });
  },
  brandDetail(params) {
    return myAxios.get("/api/screen/brand-detail", { params });
  },
  org(params) {
    return myAxios.get("/api/screen/org", { params });
  },
  duty(params) {
    return myAxios.get("/api/screen/duty", { params });
  },
  activity(params) {
    return myAxios.get("/api/screen/activity", { params });
  },
  mechanism(params) {
    return myAxios.get("/api/screen/mechanism", { params });
  },
  memberPoints(params) {
    return myAxios.get("/api/screen/member-points", { params });
  },
  branches() {
    return myAxios.get("/api/screen/branches");
  },
  stratumMembers(params) {
    return myAxios.get("/api/screen/stratum-members", { params });
  },
  politicsMembers(params) {
    return myAxios.get("/api/screen/politics-members", { params });
  },
  orgMembers(params) {
    return myAxios.get("/api/screen/org-members", { params });
  },
  repProfile(params) {
    return myAxios.get("/api/screen/rep-profile", { params });
  },
  activitiesByType(params) {
    return myAxios.get("/api/screen/activities-by-type", { params });
  },
  verifyInspect(data) {
    return myAxios.post("/api/screen/inspect/verify", data);
  }
};
